export const AssignTargetStyle = {
  noBorder: {
    border: "none",
    textAlign: "center",
  },
  paper: {
    margin: "16px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    maxHeight:
      window.innerHeight >= 1440
        ? "80vh"
        : window.innerHeight >= 1050
        ? "75vh"
        : window.innerHeight >= 900
        ? "71vh"
        : "62vh",
    height:
      window.innerHeight >= 1440
        ? "80vh"
        : window.innerHeight >= 1050
        ? "75vh"
        : window.innerHeight >= 900
        ? "71vh"
        : "62vh",

    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  tableRow: { margin: "16px", background: "#F4F6F8" },
  tableHead: { borderRadius: "14px" },
  tableCell: {
    color: "#303131",
    border: "none",
    background: "#f4f6f8",
    textAlign: "center",
  },
  outputInput: {
    borderRadius: "6px",
    height: "30px",
  },
  justifyBox: {
    width: "100%",
    display: "flex",
    justifyContent: "end",
    margin: "16px",
    padding: "16px",
  },
};
